var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('zlib'),
    deflateRawSync = _require.deflateRawSync;

var _require2 = require('../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var generateIV = require('../help/generate_iv');

var base64url = require('../help/base64url');

var getKey = require('../help/get_key');

var isObject = require('../help/is_object');

var _require3 = require('../help/key_object'),
    createSecretKey = _require3.createSecretKey;

var deepClone = require('../help/deep_clone');

var importKey = require('../jwk/import');

var _require4 = require('../errors'),
    JWEInvalid = _require4.JWEInvalid;

var _require5 = require('../jwa'),
    check = _require5.check,
    keyManagementEncrypt = _require5.keyManagementEncrypt,
    _encrypt = _require5.encrypt;

var serializers = require('./serializers');

var generateCEK = require('./generate_cek');

var validateHeaders = require('./validate_headers');

var PROCESS_RECIPIENT = Symbol('PROCESS_RECIPIENT');

var Encrypt =
/*#__PURE__*/
function () {
  "use strict";

  function Encrypt(cleartext, protectedHeader, aad, unprotectedHeader) {
    _classCallCheck(this, Encrypt);

    if (!Buffer.isBuffer(cleartext) && typeof cleartext !== 'string') {
      throw new TypeError('cleartext argument must be a Buffer or a string');
    }

    cleartext = Buffer.from(cleartext);

    if (aad !== undefined && !Buffer.isBuffer(aad) && typeof aad !== 'string') {
      throw new TypeError('aad argument must be a Buffer or a string when provided');
    }

    aad = aad ? Buffer.from(aad) : undefined;

    if (protectedHeader !== undefined && !isObject(protectedHeader)) {
      throw new TypeError('protectedHeader argument must be a plain object when provided');
    }

    if (unprotectedHeader !== undefined && !isObject(unprotectedHeader)) {
      throw new TypeError('unprotectedHeader argument must be a plain object when provided');
    }

    this._recipients = [];
    this._cleartext = cleartext;
    this._aad = aad;
    this._unprotected = unprotectedHeader ? deepClone(unprotectedHeader) : undefined;
    this._protected = protectedHeader ? deepClone(protectedHeader) : undefined;
  }
  /*
   * @public
   */


  _createClass(Encrypt, [{
    key: "recipient",
    value: function recipient(key, header) {
      key = getKey(key);

      if (header !== undefined && !isObject(header)) {
        throw new TypeError('header argument must be a plain object when provided');
      }

      this._recipients.push({
        key: key,
        header: header ? deepClone(header) : undefined
      });

      return this;
    }
    /*
     * @private
     */

  }, {
    key: PROCESS_RECIPIENT,
    value: function value(recipient) {
      var unprotectedHeader = this._unprotected;
      var protectedHeader = this._protected;
      var recipientCount = this._recipients.length;

      var jweHeader = _objectSpread({}, protectedHeader, {}, unprotectedHeader, {}, recipient.header);

      var key = recipient.key;
      var enc = jweHeader.enc;
      var alg = jweHeader.alg;

      if (key.use === 'sig') {
        throw new TypeError('a key with "use":"sig" is not usable for encryption');
      }

      if (alg === 'dir') {
        check(key, 'encrypt', enc);
      } else if (alg) {
        check(key, 'keyManagementEncrypt', alg);
      } else {
        alg = key.alg || _toConsumableArray(key.algorithms('wrapKey'))[0] || _toConsumableArray(key.algorithms('deriveKey'))[0];

        if (alg === 'ECDH-ES' && recipientCount !== 1) {
          alg = _toConsumableArray(key.algorithms('deriveKey'))[1];
        }

        if (!alg) {
          throw new JWEInvalid('could not resolve a usable "alg" for a recipient');
        }

        if (recipientCount === 1) {
          if (protectedHeader) {
            protectedHeader.alg = alg;
          } else {
            this._protected = {
              alg: alg
            };
          }
        } else {
          if (recipient.header) {
            recipient.header.alg = alg;
          } else {
            recipient.header = {
              alg: alg
            };
          }
        }
      }

      var wrapped;
      var generatedHeader;

      if (key.kty === 'oct' && alg === 'dir') {
        this._cek = importKey(key[KEYOBJECT], {
          use: 'enc',
          alg: enc
        });
      } else {
        check(this._cek, 'encrypt', enc);

        var _keyManagementEncrypt = keyManagementEncrypt(alg, key, this._cek[KEYOBJECT].export(), {
          enc: enc,
          alg: alg
        });

        wrapped = _keyManagementEncrypt.wrapped;
        generatedHeader = _keyManagementEncrypt.header;

        if (alg === 'ECDH-ES') {
          this._cek = importKey(createSecretKey(wrapped), {
            use: 'enc',
            alg: enc
          });
        }
      }

      if (alg === 'dir' || alg === 'ECDH-ES') {
        recipient.encrypted_key = '';
      } else {
        recipient.encrypted_key = base64url.encodeBuffer(wrapped);
      }

      if (generatedHeader) {
        recipient.generatedHeader = generatedHeader;
      }
    }
    /*
     * @public
     */

  }, {
    key: "encrypt",
    value: function encrypt(serialization) {
      var serializer = serializers[serialization];

      if (!serializer) {
        throw new TypeError('serialization must be one of "compact", "flattened", "general"');
      }

      if (!this._recipients.length) {
        throw new JWEInvalid('missing recipients');
      }

      serializer.validate(this._protected, this._unprotected, this._aad, this._recipients);
      var enc = validateHeaders(this._protected, this._unprotected, this._recipients, false, this._protected ? this._protected.crit : undefined);

      if (!enc) {
        enc = 'A128CBC-HS256';

        if (this._protected) {
          this._protected.enc = enc;
        } else {
          this._protected = {
            enc: enc
          };
        }
      }

      var final = {};
      this._cek = generateCEK(enc);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._recipients[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var recipient = _step.value;
          this[PROCESS_RECIPIENT](recipient);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var iv = generateIV(enc);
      final.iv = base64url.encodeBuffer(iv);

      if (this._recipients.length === 1 && this._recipients[0].generatedHeader) {
        var _this$_recipients = _slicedToArray(this._recipients, 1),
            generatedHeader = _this$_recipients[0].generatedHeader;

        delete this._recipients[0].generatedHeader;
        this._protected = _objectSpread({}, this._protected, {}, generatedHeader);
      }

      if (this._protected) {
        final.protected = base64url.JSON.encode(this._protected);
      }

      final.unprotected = this._unprotected;
      var aad;

      if (this._aad) {
        final.aad = base64url.encode(this._aad);
        aad = Buffer.concat([Buffer.from(final.protected || ''), Buffer.from('.'), Buffer.from(final.aad)]);
      } else {
        aad = Buffer.from(final.protected || '');
      }

      var cleartext = this._cleartext;

      if (this._protected && 'zip' in this._protected) {
        cleartext = deflateRawSync(cleartext);
      }

      var _encrypt2 = _encrypt(enc, this._cek, cleartext, {
        iv: iv,
        aad: aad
      }),
          ciphertext = _encrypt2.ciphertext,
          tag = _encrypt2.tag;

      final.tag = base64url.encodeBuffer(tag);
      final.ciphertext = base64url.encodeBuffer(ciphertext);
      return serializer(final, this._recipients);
    }
  }]);

  return Encrypt;
}();

module.exports = Encrypt;